module.exports = __webpack_public_path__ + "media/images/whatsapp-8f91284b5122ba65ed36941523146613.svg";